import React from 'react'
import PropTypes from 'prop-types'
import { Card, Text, Gallery, Label, TextArea, Title } from '../tools'

function AllEditor({ setting }) {
  const {
    type,
    content,
    label,
    addItem,
    removeItem,
    setType = () => {},
  } = setting

  return (
    <div>
      {type === 'title' && (
        <Title
          setting={{
            content,
          }}
        />
      )}

      {type === 'text' && (
        <Text
          setting={{
            content,
            label,
          }}
        />
      )}

      {type === 'card' && (
        <Card
          setting={{
            label,
            content,
            addItem,
            removeItem,
            hideToolbar: false,
          }}
        />
      )}

      {type === 'gallery' && (
        <Gallery
          setting={{
            imgs: content || [],
            setType,
          }}
        />
      )}

      {type === 'story-card' && (
        <div className="inner shadow-block">
          <Label
            setting={{
              label: '',
              title: content.title,
              edit: true,
            }}
          />
          {content.isLoading ? (
            <Loading setting={{ style: 'one' }} />
          ) : (
            <div style={{ marginLeft: '-20px', marginRight: '-20px' }}>
              <TextArea
                setting={{
                  label: '',
                  value: content.content,
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

function Loading({ setting }) {
  const { style } = setting

  if (style === 'one') {
    return (
      <div
        className="loading-wrap"
        style={{
          position: 'static',
        }}
      >
        <div className="loading-bar">loading</div>
      </div>
    )
  }

  return (
    <div className="loading-wrap">
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar mb-4">loading</div>
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar">loading</div>
    </div>
  )
}

AllEditor.propTypes = {
  setting: PropTypes.shape().isRequired,
}

Loading.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default AllEditor
